import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";

const ZebraResult = ({ item }) => {
  const table = (
    <table className="varsome-table">
      <tbody>
        <tr>
          {item?.zfin_zebrafish_gene && (
            <td>
              <div className="varsome-horiz-list-item">
                <div className="varsome-horiz-list-label">Gene</div>
                <div className="varsome-horiz-list-value">
                  {item?.zfin_zebrafish_gene}
                </div>
              </div>
            </td>
          )}
          {item?.zfin_zebrafish_phenotype_quality && (
            <td>
              <div className="varsome-horiz-list-item">
                <div className="varsome-horiz-list-label">
                  Phenotype Quality
                </div>
                <div className="varsome-horiz-list-value">
                  {item?.zfin_zebrafish_phenotype_quality}
                </div>
              </div>
            </td>
          )}
          {item?.zfin_zebrafish_phenotype_tag && (
            <td>
              <div className="varsome-horiz-list-item">
                <div className="varsome-horiz-list-label">Phenotype Tag</div>
                <div className="varsome-horiz-list-value">
                  {item?.zfin_zebrafish_phenotype_tag}
                </div>
              </div>
            </td>
          )}
          {item?.zfin_zebrafish_structure && (
            <td>
              <div className="varsome-horiz-list-item">
                <div className="varsome-horiz-list-label">Structure</div>
                <div className="varsome-horiz-list-value">
                  {item?.zfin_zebrafish_structure}
                </div>
              </div>
            </td>
          )}
        </tr>
      </tbody>
    </table>
  );

  const zebraResult = (
    <>
      <div className="tw-mt-7">
        <h5>
          <a href={getVarsoUrl("https://zfin.org/")} target="_blank">
            ZFIN - Zebrafish Information Network
          </a>
        </h5>
      </div>
      {table}
    </>
  );

  return zebraResult;
};

const { string, shape } = PropTypes;

ZebraResult.propTypes = {
  item: shape({
    zfin_zebrafish_phenotype_tag: string,
    zfin_zebrafish_structure: string,
    zfin_zebrafish_phenotype_quality: string,
    zfin_zebrafish_gene: string,
  }),
};

ZebraResult.defaultProps = {
  item: null,
};
export default ZebraResult;
